module.exports = __webpack_public_path__ + "img/share-outline.8594c1b4.svg";